export default __webpack_public_path__ + "static/media/smart.7f31ad85.png";